import { render, staticRenderFns } from "./CollectionComponent.vue?vue&type=template&id=4670cf2c&scoped=true&"
import script from "./CollectionComponent.vue?vue&type=script&lang=js&"
export * from "./CollectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./CollectionComponent.vue?vue&type=style&index=0&id=4670cf2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4670cf2c",
  null
  
)

export default component.exports